import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CORE_SERVICE_URLS } from '~/Constants/Urls.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { ProviderAccounting } from '~/Models/DTO/ProviderAccounting.model';
import {
  requestCurrencyList,
  selectCurrencyList,
  selectCurrencyListError,
  selectCurrencyListLoading,
} from '~/store/payments/currencies';
import { useProvider } from '..';
import { useRequest } from '../useRequest';
export const useCurrencyListHook = () => {
  const dispatch = useDispatch();
  const { currentProvider } = useProvider();
  const { requestWithCallback } = useRequest();

  const currencyList = useSelector(selectCurrencyList);
  const loading = useSelector(selectCurrencyListLoading);
  const error = useSelector(selectCurrencyListError);

  // State
  const [providerCurrencyId, setProviderCurrencyId] = useState(1);

  const getCurrencyList = bindActionCreators(requestCurrencyList, dispatch);

  useEffect(() => {
    getCurrencyList();
  }, []);

  useEffect(() => {
    const getCurrency = async () => {
      await requestWithCallback<ProviderAccounting>(
        {
          url: routeReplacer(CORE_SERVICE_URLS.PROVIDER_ACCOUNT, {
            domain: currentProvider?.domain || '',
          }),
          method: 'GET',
        },
        (data) => {
          setProviderCurrencyId(data.currencyId);
        },
      );
    };
    getCurrency();
  }, [currentProvider]);

  return {
    currencyList: currencyList.filter((item) => item.id === providerCurrencyId),
    currencyListError: error,
    isCurrencyListLoading: loading,
  };
};
